import { CREATE_REVIEW_PARAM } from 'shared/containers/ReviewsSnippetContainer/constants';

interface ICreateUrlParams {
  objectId: number;
  initialUrl: string;
  openCreateReview?: boolean;
}

export const createUrl = ({ objectId, initialUrl, openCreateReview }: ICreateUrlParams) => {
  const parsedUrl = new URL(initialUrl);

  // Удаляем параметры поиска
  parsedUrl.search = '';

  // Получаем путь и разбиваем его на части
  const pathParts = parsedUrl.pathname.split('/').filter(Boolean);

  // Проверяем, что путь имеет ровно 3 части
  if (pathParts.length !== 3) {
    return initialUrl;
  }

  // Вместо id из урлы вставляем свой. Это нужно, потому что cianId и realtyId не всегда совпадают,
  // а отзывы работают только с realtyId
  pathParts[2] = String(objectId);

  // Добавляем роут для отзывов
  pathParts.push('reviews');

  // Собираем обновленный путь
  parsedUrl.pathname = pathParts.join('/');

  parsedUrl.search = openCreateReview ? `?${CREATE_REVIEW_PARAM}` : '';

  return parsedUrl.toString();
};
